module.exports = __webpack_public_path__ + "98d6a8aeec2fbcba94bac0dc7c2a8f7e.png";